<template>
  <div class="parcare-auto-container10">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name9"
    ></app-navigation>
    <main class="parcare-auto-main">
      <div id="transport" class="parcare-auto-hero section-container">
        <div class="parcare-auto-max-width1 max-content-container">
          <div class="parcare-auto-content-container">
            <h1 class="parcare-auto-text10">
              <span>
                COMBINATUL AUTO
                <span v-html="raws0yd"></span>
              </span>
              <span class="parcare-auto-text12">nr.4</span>
              <br />
              <span class="parcare-auto-text14">s</span>
              <span class="parcare-auto-text15">ervicii de</span>
              <br />
              <span class="parcare-auto-text17">calitate</span>
              <br />
              <span class="parcare-auto-text18">
                IN
                <span v-html="rawi6xc"></span>
              </span>
              <span class="parcare-auto-text19">Moldova</span>
            </h1>
            <span class="parcare-auto-text20">
              <span>N</span>
              <span class="parcare-auto-text22">
                oi garantam executarea rapida si la un nivel
              </span>
              <br />
              <span class="parcare-auto-text24">
                inalt a comenzilor Dvs.
                <span v-html="rawfux5"></span>
              </span>
            </span>
            <div class="parcare-auto-btns-container">
              <a
                href="https://combinatulauto.md/#servicii"
                target="_blank"
                rel="noreferrer noopener"
                class="parcare-auto-primary button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="https://combinatulauto.md/#contacts"
                target="_blank"
                rel="noreferrer noopener"
                class="parcare-auto-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="parcare-auto-video-container">
            <div class="parcare-auto-container11"></div>
          </div>
        </div>
        <div class="parcare-auto-blue-background"></div>
      </div>
      <div class="parcare-auto-text-content">
        <h1 class="parcare-auto-text25">parcare auto</h1>
        <span class="parcare-auto-text26">
          livrare in toata republica moldova
        </span>
        <span class="parcare-auto-text27">
          <span>
            SA „Combinatul Auto Nr.4 din Chișinău”
            <span v-html="rawdqnc"></span>
          </span>
          <span class="parcare-auto-text29">
            dispune de mai multe camioane pentru transportarea marfurilor atit pe
            teritoriul Mun.
            <span v-html="raw6zmx"></span>
          </span>
          <span class="parcare-auto-text30">Chisinau</span>
          <span class="parcare-auto-text31">
            cat si prin
            <span v-html="rawphs5"></span>
          </span>
          <span class="parcare-auto-text32">republica</span>
          <span class="parcare-auto-text33">.</span>
          <br />
          <span></span>
          <span class="parcare-auto-text36">
            Pe
            <span v-html="raw79q4"></span>
          </span>
          <span class="parcare-auto-text37">
            teritoriul Combinatului Auto Nr. 4
            <span v-html="rawdjct"></span>
          </span>
          <span class="parcare-auto-text38">
            Chisinau
            <span v-html="rawrfyv"></span>
          </span>
          <span class="parcare-auto-text39">
            sunt mai multe zone de parcare care pot fi inchiriate.
          </span>
          <br />
          <span class="parcare-auto-text40">
            Intrarea
            <span v-html="rawdt0l"></span>
          </span>
          <span class="parcare-auto-text41">
            pe teritoriul intreprinderii este verificata de paznic 24/24.
          </span>
          <br />
          <span class="parcare-auto-text42">Teritoriul</span>
          <span class="parcare-auto-text43">
            intreprinderii este monitorizat de camere de monitorizare video.
          </span>
          <span></span>
          <br />
          <span></span>
        </span>
      </div>
      <div class="parcare-auto-gallery">
        <div class="parcare-auto-container12">
          <div class="parcare-auto-container13"></div>
        </div>
        <div class="parcare-auto-container14">
          <div class="parcare-auto-container15"></div>
        </div>
        <div class="parcare-auto-container16">
          <div class="parcare-auto-container17"></div>
        </div>
        <div class="parcare-auto-container18">
          <div class="parcare-auto-container19"></div>
        </div>
        <div class="parcare-auto-container20">
          <div class="parcare-auto-container21"></div>
        </div>
        <div class="parcare-auto-container22">
          <div class="parcare-auto-container23"></div>
        </div>
      </div>
      <div class="parcare-auto-numbers-banner section-container">
        <div class="parcare-auto-container24 max-content-container">
          <div class="parcare-auto-heading-container1">
            <span class="parcare-auto-text46">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu.
              <span v-html="rawbvb3"></span>
            </span>
            <h1 class="parcare-auto-text47 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="rawrf9t"></span>
              </span>
            </h1>
          </div>
          <div class="parcare-auto-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="parcare-auto-previous-events section-container">
        <div class="parcare-auto-max-width2 max-content-container">
          <div class="parcare-auto-heading-container2">
            <h1 class="parcare-auto-text49 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="parcare-auto-text51">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name9"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'ParcareAuto',
  props: {},
  components: {
    AppNavigation,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      raws0yd: ' ',
      rawi6xc: ' ',
      rawfux5: ' ',
      rawdqnc: ' ',
      raw6zmx: ' ',
      rawphs5: ' ',
      raw79q4: ' ',
      rawdjct: ' ',
      rawrfyv: ' ',
      rawdt0l: ' ',
      rawbvb3: ' ',
      rawrf9t: ' ',
    }
  },
  metaInfo: {
    title: 'Parcare-Auto - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Parcare-Auto - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.parcare-auto-container10 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.parcare-auto-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-hero {
  position: relative;
  padding-top: 128px;
}
 
.parcare-auto-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.parcare-auto-content-container {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.parcare-auto-text10 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.parcare-auto-text12 {
  text-transform: lowercase;
}
 
.parcare-auto-text14 {
  color: var(--dl-color-scheme-pink);
}
 
.parcare-auto-text15 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.parcare-auto-text17 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.parcare-auto-text18 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.parcare-auto-text19 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.parcare-auto-text20 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.parcare-auto-text22 {
  text-transform: lowercase;
}
 
.parcare-auto-text24 {
  text-transform: lowercase;
}
 
.parcare-auto-btns-container {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.parcare-auto-primary {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.parcare-auto-secondary {
  text-decoration: none;
}
 
.parcare-auto-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.parcare-auto-container11 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-600h.webp");
  background-position: center;
}
 
.parcare-auto-container11:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.parcare-auto-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.parcare-auto-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  justify-content: space-between;
}
 
.parcare-auto-text25 {
  font-size: 3rem;
  text-align: center;
}
 
.parcare-auto-text26 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.parcare-auto-text27 {
  max-width: var(--dl-size-size-maxwidth);
  margin-top: var(--dl-space-space-twounits);
  text-align: center;
  margin-bottom: var(--dl-space-space-twounits);
  text-transform: uppercase;
}
 
.parcare-auto-text29 {
  text-transform: lowercase;
}
 
.parcare-auto-text30 {
  text-transform: capitalize;
}
 
.parcare-auto-text31 {
  text-transform: lowercase;
}
 
.parcare-auto-text32 {
  text-transform: capitalize;
}
 
.parcare-auto-text33 {
  text-transform: lowercase;
}
 
.parcare-auto-text36 {
  text-transform: capitalize;
}
 
.parcare-auto-text37 {
  text-transform: lowercase;
}
 
.parcare-auto-text38 {
  text-transform: capitalize;
}
 
.parcare-auto-text39 {
  text-transform: lowercase;
}
 
.parcare-auto-text40 {
  text-transform: capitalize;
}
 
.parcare-auto-text41 {
  text-transform: lowercase;
}
 
.parcare-auto-text42 {
  text-transform: capitalize;
}
 
.parcare-auto-text43 {
  text-transform: lowercase;
}
 
.parcare-auto-gallery {
  width: 100%;
  height: 1200px;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  max-width: var(--dl-size-size-maxwidth);
  align-self: center;
  align-items: flex-start;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  padding-bottom: var(--dl-space-space-twounits);
  grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas: "a b b" "a b b" "a c d" "a c d"  "e e d" "e e f" "e e f";
  grid-template-columns: 1fr 1fr 1fr;
}
 
.parcare-auto-container12 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  opacity: 1;
  grid-area: a;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-container12:hover {
  transform: scale(0.98);
}
 
.parcare-auto-container13 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/13-1200h.webp");
  background-position: left;
}
 
.parcare-auto-container14 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: b;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/22-1200h.webp");
  background-position: center;
}
 
.parcare-auto-container14:hover {
  transform: scale(0.98);
}
 
.parcare-auto-container15 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-container16 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: c;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/15-1200h.webp");
  background-position: left;
}
 
.parcare-auto-container16:hover {
  transform: scale(0.98);
}
 
.parcare-auto-container17 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-container18 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: d;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/23-1200h.webp");
  background-repeat: no-repeat;
  background-position: left;
}
 
.parcare-auto-container18:hover {
  transform: scale(0.98);
}
 
.parcare-auto-container19 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-container20 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: e;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/20-1200h.webp");
  background-position: center;
}
 
.parcare-auto-container20:hover {
  transform: scale(0.98);
}
 
.parcare-auto-container21 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-container22 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  grid-area: f;
  transition: 0.3s;
  align-items: flex-start;
  flex-direction: column;
  background-size: cover;
  background-image: url("/24-1200h.webp");
  background-position: center;
}
 
.parcare-auto-container22:hover {
  width: 100%;
  height: 100%;
  transform: scale(0.98);
}
 
.parcare-auto-container23 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: var(--dl-space-space-unit);
  align-items: flex-start;
  flex-direction: column;
}
 
.parcare-auto-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/29bg-1500w.webp");
}
 
.parcare-auto-container24 {
  flex-direction: column;
}
 
.parcare-auto-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.parcare-auto-text46 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.parcare-auto-text47 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.parcare-auto-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.parcare-auto-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.parcare-auto-max-width2 {
  flex-direction: column;
}
 
.parcare-auto-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.parcare-auto-text49 {
  text-align: center;
}
 
.parcare-auto-text51 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .parcare-auto-max-width1 {
    flex-direction: column;
  }
  .parcare-auto-content-container {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .parcare-auto-container11 {
    width: 583px;
  }
  .parcare-auto-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .parcare-auto-text27 {
    max-width: 100%;
  }
  .parcare-auto-gallery {
    grid-gap: var(--dl-space-space-unit);
  }
  .parcare-auto-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
 
@media(max-width: 767px) {
  .parcare-auto-container11 {
    width: 505px;
  }
  .parcare-auto-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .parcare-auto-text27 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .parcare-auto-gallery {
    height: auto;
    display: flex;
    padding: var(--dl-space-space-twounits);
    flex-direction: column;
  }
  .parcare-auto-container13 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container15 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container17 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container19 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container21 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container23 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .parcare-auto-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .parcare-auto-text10 {
    font-size: 60px;
  }
  .parcare-auto-container11 {
    width: 424px;
  }
  .parcare-auto-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .parcare-auto-gallery {
    width: 100%;
    padding: var(--dl-space-space-unit);
  }
  .parcare-auto-container13 {
    width: 100%;
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container15 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container17 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container19 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container21 {
    height: var(--dl-size-size-xxlarge);
  }
  .parcare-auto-container23 {
    height: var(--dl-size-size-xxlarge);
  }
}
</style>
